import React, { useState, useEffect, useContext } from 'react';
import './App.css';
import ChatWindow from './ChatWindow';
import LoginScreen from './LoginScreen';
import { AppContext } from './contexts/AppContext';
import TokenManager from './TokenManager'; // ✨ 1. [토큰 로직] API 요청에 필요한 토큰 관리자를 임포트합니다.

function App() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { theme } = useContext(AppContext);
  const API_URL = process.env.REACT_APP_API_URL || '';

  // [추가] Safari 100vh 이슈 해결을 위한 높이 계산 로직
  useEffect(() => {
    const setAppHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    };
    window.addEventListener('resize', setAppHeight);
    setAppHeight(); // 초기 로드 시 실행

    return () => window.removeEventListener('resize', setAppHeight);
  }, []);


  useEffect(() => {
    const savedUserId = localStorage.getItem('ego-coach-userId');
    if (savedUserId) {
      handleLogin(savedUserId, false);
    } else {
      setIsLoading(false);
    }
  }, []);

  const handleLogin = async (idToLogin, isNew = false) => {
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/user/find-or-create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId: idToLogin, isNew })
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || '서버에서 오류가 발생했습니다.');
      }
      
      // ✨ 2. [토큰 로직] 로그인(find-or-create) 응답에서 최초 토큰을 추출합니다.
      const initialToken = data.activeRequestToken;

      // ✨ 3. [토큰 로직] 추출한 토큰을 TokenManager에 저장하여 첫 메시지 전송에 사용될 수 있도록 합니다.
      if (initialToken) {
        TokenManager.setToken(initialToken);
      }

      localStorage.setItem('ego-coach-userId', data.userId);
      setUser(data);
    } catch (err) {
      setError(err.message || '서버에 연결할 수 없습니다.');
      localStorage.removeItem('ego-coach-userId');
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('ego-coach-userId');
    setUser(null);
    setError('');
  };

  const handleUserDataUpdate = (updatedData) => {
    setUser(prevUser => ({
      ...prevUser,
      userData: updatedData
    }));
  };

  if (isLoading && !user) {
    return <div className="loading-fullscreen">... EGO 코치 로딩 중 ...</div>;
  }

  return (
    <div className="App" data-theme={theme}>
      {!user ? (
        <LoginScreen onLogin={handleLogin} error={error} isLoading={isLoading} />
      ) : (
        <div className="main-container">
            <ChatWindow
              userId={user.userId}
              userData={user.userData}
              initialMessages={user.messages}
              onLogout={handleLogout}
              onUserDataUpdate={handleUserDataUpdate}
            />
        </div>
      )}
    </div>
  );
}

export default App;
